var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B66B0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 32,
    cy: 15.9,
    r: 6.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.2,26.7c-0.6-0.6-1.3-1-2-1.4c-2.6,2.8-7,2.9-9.8,0.3c-0.1-0.1-0.2-0.2-0.3-0.3c-3.3,1.8-5.4,5.3-5.4,9.1 v4.4c0,0.8,0.6,1.4,1.4,1.4h10.1v-0.9C12.4,34.3,14.5,29.8,18.2,26.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.8,25.2c-2.6,2.8-7,2.9-9.8,0.3c-0.1-0.1-0.2-0.2-0.3-0.3c-0.7,0.4-1.3,0.9-1.9,1.4 c3.7,3.1,5.8,7.7,5.8,12.5v0.9h10.1c0.8,0,1.4-0.6,1.4-1.4v-4.4C63.1,30.5,61.1,27,57.8,25.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 52.7,
    cy: 20.5,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 11.3,
    cy: 20.5,
    r: 4.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.2,25.1h-6.5c-7.8,0-14.1,6.3-14.1,14.1v13c0,1.6,1.3,2.9,2.9,2.9h28.8c1.6,0,2.9-1.3,2.9-2.9v-13 C49.3,31.4,43,25.1,35.2,25.1z M47,52.2c0,0.3-0.3,0.6-0.6,0.6H17.6c-0.3,0-0.6-0.3-0.6-0.6v-13c0-6.4,5.1-11.6,11.5-11.8 c0,1.3,0.8,2.5,1.9,3.1L28.5,41l3.5,8.3l3.5-8.3l-1.9-10.5c1.2-0.6,1.9-1.8,1.9-3.1C41.9,27.5,47,32.7,47,39.1V52.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardResources);
export default __webpack_public_path__ + "static/media/card-resources.81352689e4ff848ad009ce1cd163bba6.svg";
export { ForwardRef as ReactComponent };